import { COHORTS, useCohort } from "@/components/user-context";

import { LoggedInRovoDevStandardExistingSitesUser } from "./existing-sites-user";
import { LoggedInRovoDevStandardNewUser } from "./new-user";

export const LoggedInRovoDevStandard = () => {
    const cohort = useCohort();

    if (cohort === COHORTS.NEW_USER) {
        return <LoggedInRovoDevStandardNewUser />;
    }

    if (cohort) {
        return <LoggedInRovoDevStandardExistingSitesUser />;
    }

    return null;
};
